// extracted by mini-css-extract-plugin
export default {"card-title":"Card_card-title__bMsyM"};